import React from "react";
import { CircularProgress, styled } from "@mui/material";

const Container = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
}));

const CentredCircularProgress: React.FC = () => {
  return (
    <Container>
      <CircularProgress />
    </Container>
  );
};

export default CentredCircularProgress;
